import { Pipe, PipeTransform } from '@angular/core';
import { ConnectedFieldModel } from '@seahorse/domain';

@Pipe({
  name: 'getFieldName',
  standalone: true,
})
export class GetFieldNamePipe implements PipeTransform {
  transform(field: ConnectedFieldModel): string {
    const fieldDef = field.objectDefinition?.objectFieldDefinitions?.find(
      (f) => f.systemCode === field.targetField
    );
    return fieldDef?.name || field.targetField;
  }
}
